/**
 * 정기결제 결과 페이지 라우트
 * FSD: pages/subscription-checkout-result
 */

import { RouteObject } from 'react-router-dom';
import SubscriptionCheckoutResultPage from './ui/SubscriptionCheckoutResultPage';

export const subscriptionCheckoutResultRoute: RouteObject = {
  path: '/subscription/checkout/result',
  element: <SubscriptionCheckoutResultPage />,
};
